export const URL_HOME = '/';
export const URL_LOGIN = '/login';
export const URL_LOGOUT = '/logout';
export const URL_PRE_SET_LOGIN = '/pre-set-login';
export const URL_REGISTER_MISSING_EMAIL = '/register/missing_email';
export const URL_REGISTER = '/register/';
export const URL_CHOICE_REGISTER = '/register/choice';
export const URL_RESETTING_PASSWORD = '/resetting/request';
export const URL_NEWSLETTER = '/newsletter';
export const URL_CONTACT = '/contactez-nous';
export const URL_IDEAL_LOCATION = '/emplacement-ideal-bureaux';
export const URL_USER_OFFERS = '/offers';
export const URL_OFFER = '/office-offer/{hashId}';
export const URL_OFFER_VIEW = '/office-offer/view/{id}';
export const URL_OFFER_VIEW_ENDPOINT = '/office-offer/view';
export const URL_XHR_OFFER_EDIT = '/xhr/office-offer/bulk-edit';
export const URL_OFFER_ACTION_DELETE = '/office-offer/state/delete/{id}';
export const URL_OFFER_ACTION_UNPUBLISH = '/office-offer/state/unpublish/{id}';
export const URL_OFFER_ACTION_REVIEW = '/office-offer/state/review/{id}';
export const URL_OFFER_ACTION_EDIT = '/office-offer/state/edit/{id}';
export const URL_OFFER_CREATE = '/office-offer/setup/';
export const URL_OFFER_SETUP = '/office-offer/setup/{step}/edit/{id}';
export const URL_SELECTION_ITEM_LIST = '/my-search/recommendations';
export const URL_SELECTION_ITEM_DASHBOARD = '/my-search/board';
export const URL_COMPARATOR = '/my-search/comparator';
export const URL_OFFER_FAVORITE_SET = '/office-offer/favorite/set/{id}';
export const URL_OFFER_PROPOSAL_ADD = '/office-offer/proposal';
export const URL_OFFER_PROPOSAL_ARCHIVE = '/office-offer/proposal/{id}/archive';
export const URL_OFFER_PROPOSAL_UPDATE = '/office-offer/proposal/{id}';
export const URL_SELECTION_ITEM_REMOVE = '/selection-items/{id}';
export const URL_SELECTION_ITEM_RESTORE = '/selection-items/{id}/restore';
export const URL_SELECTION_ITEM_PROPOSAL_CREATE = '/selection-items/{id}/proposals';
export const URL_SELECTION_ITEM_AI_GENERATE_REVIEW = '/selection-items/{id}/ai';
export const URL_SELECTION_ITEM_LIKE = '/selection-items/{id}/like';
export const URL_SELECTION_ITEMS_GET = '/selection-items';
export const URL_XHR_SELECTION_ITEMS_SORT = '/xhr/selection-items/sort';
export const URL_XHR_PROPOSAL_SEND_EMAIL = '/xhr/proposals/send-email';
export const URL_DEALUDUR_MARKER_CREATE = '/deal-udur-markers';
export const URL_DEALUDUR_MARKER_REMOVE = '/deal-udur-markers/remove';
export const URL_XHR_CREATE_SEARCH_COMMENT_TIMELINE = '/xhr/search-comment-timelines';
export const URL_XHR_SEARCH_COMMENT_TIMELINES = '/xhr/search-comments/{searchCommentId}/search-comment-timelines';
export const URL_USER_DELETE_MODAL = '/profile/delete-modal';
export const URL_USER_INBOX = '/profile/inbox';
export const URL_USER_INBOX_ARCHIVED = '/profile/inbox-archived';
export const URL_DEAL = '/deal/{id}';
export const URL_DEAL_MESSAGING = '/profile/deal/{id}/messaging';
export const URL_ADAF = '/organization/business_input';
export const URL_USER_LEADS = '/leads';
export const URL_USER_PROPOSAL = '/my-search/recommendations';
export const URL_DEAL_CHANGE_STATE = '/profile/deal/{id}/change-state-{state}';
export const URL_USERFILE_DOWNLOAD = '/userfile/{uuid}/download';
export const URL_USERFILE_PREVIEW = '/userfile/{uuid}/preview';
export const URL_USER_PROFILE_MANAGE = '/profile/manage';
export const URL_USER_NOTIFICATIONS = '/profile/notifications';
export const URL_USER_PROFILE_INVOICE = '/profile/invoice';
export const URL_USER_ORGANIZATION_PAYMENT_METHOD_SELLER = '/organization/payment-method/seller';
export const URL_USER_ORGANIZATION_PAYMENT_METHOD_BUYER = '/organization/payment-method/buyer';
export const URL_USER_ORGANIZATION_MANAGE = '/organization/manage';
export const URL_SELLER_ORGANIZATION_MANAGE = '/invoicing/manage';
export const URL_USER_ORGANIZATION_PAYMENT_ACCOUNT = '/organization/payment-account';
export const URL_SUBSCRIPTION_LANDING_PAGE = '/prelevement-automatique';

// FIXME : find a way to translate that depending on locale
export const URL_SEARCH = '/recherche';
export const URL_PUBLISH_OFFER = '/publier-une-annonce';
export const URL_GUIDED_SEARCH = '/confier-ma-recherche';
export const URL_USER_SETTINGS_ONBOARDING_LEADS = '/me/settings/onboarding_leads';
export const URL_USER_SETTINGS_ONBOARDING_MATCH_RDV = '/me/settings/onboarding_match_rdv';
export const URL_USER_SETTINGS_ONBOARDING_ADAF = '/me/settings/onboarding_adaf';
export const URL_USER_SETTINGS_ONBOARDING_TEMPLATES = '/me/settings/onboarding_templates';
export const URL_USER_SETTINGS_ONBOARDING_SPACES = '/me/settings/onboarding_spaces';
export const URL_USER_SETTINGS_ONBOARDING_SPACES_LIST = '/me/settings/onboarding_spaces_list';
export const URL_USER_NOTIFICATIONS_POLL = '/me/notifications';
export const URL_SEARCH_NEAR_TRANSPORTS = '/search-api/near-transports';
export const URL_SUBSCRIPTION_CREATE = '/invoicing/subscriptions/create';
export const URL_SUBSCRIPTION_EDIT = '/invoicing/subscriptions/{id}';
export const URL_SUBSCRIPTION = '/invoicing/subscriptions';
export const URL_INVOICES = '/invoicing/invoices';
export const URL_BUYER_INVOICES = '/invoicing/invoices/buyer';
export const URL_PAYOUTS = '/invoicing/payouts';
export const URL_INVOICING_HEADER_INFOS = '/invoicing/header-infos';
export const URL_MANAGEMENT_INVOICES = '/management-invoices';
export const URL_CUSTOMER_PORTAL_CONNECTED = '/invoicing/customer-portal?use_current_connected_user=true';

// Messaging
export const URL_CREATE_MESSAGE_DEAL = '/profile/deal/{id}/create-message';
export const URL_ORGANIZE_VISIT = '/xhr/profile/deal/{id}/organize-visit';
export const URL_GET_ICS = '/xhr/profile/deal/{id}/get-ics';
export const URL_ACCEPT_SLOT = '/xhr/deal/{id}/accept-slot';
export const URL_PROPOSE_SLOTS = '/xhr/deal/{id}/propose-slots';
export const URL_DEAL_CONTACT_TIMELINE = '/xhr/profile/deal/{id}/messaging';
export const URL_SUPPORT_CONVERSATION_TIMELINE = '/xhr/profile/support_conversation/{id}/messaging';
export const URL_GET_INVOICES_FROM_SUBSCRIPTION = '/xhr/invoicing-deal/{id}/invoices';
export const URL_CREATE_DEAL_VISIT_SUMMARY = '/xhr/deal/{id}/visit-summary';
export const URL_CREATE_MESSAGE_TEMPLATE_USER = '/xhr/deal-template-message/create';
export const URL_UPDATE_MESSAGE_TEMPLATE_USER = '/xhr/deal-template-message/update/{id}';
export const URL_UPDATE_LIST_MESSAGE_TEMPLATE_USER = '/xhr/deal-template-message/update-list';

// xhr routes
export const URL_ADAF_MONTH = '/xhr/adaf/month/{month}';
export const URL_ADAF_CALC_SUM_PRICE = '/xhr/adaf/calc-sum-prices/{month}';
export const URL_ADAF_DEALPAYMENT_UPDATE = '/xhr/adaf/dealpayment/{id}/update';
export const URL_ADAF_DEAL_END = '/xhr/adaf/deal/{id}/end';
export const URL_ADAF_DEAL_EXTEND = '/xhr/adaf/deal/{id}/extend';
export const URL_OFFER_STATISTICS = '/xhr/office-offer/statistics/{hashid}';
export const URL_XHR_DEALS = '/xhr/deals/{state}/{page}';
export const URL_XHR_DEAL_CHANGE_STATE_ARCHIVED = '/xhr/deal/{id}/archive';
export const URL_XHR_DEAL_CHANGE_STATE_RESTORED = '/xhr/deal/{id}/restore';
export const URL_XHR_SUBSCRIPTION_CREATE = '/xhr/invoicing/create-subscription';
export const URL_XHR_SUBSCRIPTION_MODIFY = '/xhr/invoicing/subscriptions/{id}';
export const URL_XHR_GET_UNIQUE_BUYERS = '/xhr/subscriptions/buyers';
export const URL_XHR_INVOICES_ENDPOINT = '/xhr/invoices';
export const URL_XHR_UPDATE_INVOICE_STATUS_ENDPOINT = '/xhr/invoices/{type}/{id}/{status}';
export const URL_XHR_CREDIT_NOTE_ENDPOINT = '/xhr/credit_notes';
export const URL_XHR_DISCOUNT_ENDPOINT = '/xhr/discounts';
export const URL_XHR_CREATE_CHECKOUT_SESSION = '/xhr/invoicing/create-checkout-session';
export const URL_XHR_DEAL_STATE_SIGNED = '/xhr/deal/{id}/change-state-signed';
export const URL_XHR_DEAL_STATE_UNSIGNED = '/xhr/deal/{id}/change-state-unsigned';
export const URL_XHR_DEAL_VISIT_FEEDBACK = '/xhr/deal/{id}/save-feedback';
export const URL_XHR_DEAL_CANCEL_VISIT = '/xhr/deal/{id}/cancel-visit';
export const URL_XHR_DEAL_MARK_AS_UNREAD = '/xhr/deal/{id}/mark-unread';
export const URL_XHR_DEAL_VIEW_PHONE_NUMBER = '/xhr/deal/{id}/view-phone-number';
export const URL_XHR_DELETE_TEMPLATE = '/xhr/deal-template-message/delete/{id}';
export const URL_XHR_BUYER_DASHBOARD_VISIT_SLOT_CHOICE = '/xhr/common-dashboard/deal/{id}/visit-slot-choice';
export const URL_XHR_BUYER_DASHBOARD_DEAL_ARCHIVE = '/xhr/deal-dashboard/deal/{id}/archive';
export const URL_XHR_BUYER_DASHBOARD_PROPOSALS = '/xhr/buyer-dashboard/proposals';
export const URL_XHR_DEAL_UDUR_UPDATE = '/xhr/deal_udurs/{id}';
export const URL_XHR_DEAL_UDUR_OFFERS_COUNT = '/xhr/deal_udurs/{id}/offers_count';
export const URL_XHR_DEAL_UDUR_LAST_OFFERS_COUNT = '/xhr/deal_udurs/{id}/last_offers_count';
export const URL_ORGANIZATION_BUSINESS_INPUT_DOWNLOAD = '/organization/business_input/download?start_month=%start_month%&end_month=%end_month%';
export const URL_INBOX = '/xhr/inbox/{page}';
export const URL_XHR_INBOX_READ_STATUS = '/xhr/inbox/{type}/{id}/set-{action}';
export const URL_INVOICE = '/xhr/invoice/{page}/{sortField}-{sortOrder}';
export const URL_XHR_INVOICE_REMAINING = '/xhr/invoices/{id}/remaining';
export const URL_LEADS = '/xhr/leads/{page}';
export const URL_XHR_OFFERS = '/xhr/offers';
export const URL_XHR_PAY_ORGANIZATION_BILLING_INFORMATIONS = '/xhr/{organizationType}/{billingType}/billing-information';
export const URL_XHR_GET_ONBOARDING_LINK = '/xhr/invoicing/onboarding-account';
export const URL_ADDRESS_PAGE = '/spaces';
export const URL_ADDRESS_DETAILS = '/spaces/{id}';
export const URL_XHR_ADDRESSES = '/xhr/addresses';
export const URL_XHR_ADDRESS_ID = '/xhr/addresses/{id}';
export const URL_XHR_ADDRESS_INFORMATIONS_UPDATE = '/xhr/addresses/{id}/informations';
export const URL_XHR_ADDRESS_SERVICES_UPDATE = '/xhr/addresses/{id}/services';
export const URL_XHR_ADDRESSES_FAVORITE = '/xhr/addresses-favorite';
export const URL_XHR_ALGOLIA_OFFERS = '/xhr/algolia/offers';
export const URL_XHR_ALGOLIA_OFFERS_COUNT = '/xhr/algolia/offers/count';
export const URL_XHR_ALGOLIA_SPACES_COUNT = '/xhr/algolia/spaces/count';
export const URL_ADDRESS_CONTACT_PAGE = '/contacts/{id}';
export const URL_ADDRESS_CONTACT_PAGE_CHANGE_PRIMARY = '/xhr/contacts/{id}/primary';
export const URL_ADDRESS_CONTACT_SECONDARY = '/xhr/contacts/{id}/secondary';
export const URL_ADDRESS_CONTACT_SECONDARY_DELETE = '/xhr/contacts/{id}/secondary/{userId}';
export const URL_SELLER_ONBOARDING_RESEND_EMAIL = '/xhr/seller-onboarding/init-password';
export const URL_OFFER_CONTACT_RESEND_EMAIL = '/xhr/offer-contact/init-password';
export const URL_REGISTER_RESEND_EMAIL = '/xhr/register/activate-account';
export const URL_GET_LAST_TIME_USER_ONLINE = '/xhr/get-last-time-user-online/{id}';
export const URL_HOLIDAY_BANNER_CLOSE = '/xhr/user/holiday-banner/close';
export const URL_CHANGE_SUPERVISOR = '/xhr/deal/{id}/change-supervisor';
export const URL_GUIDED_SEARCH_CREATE = '/xhr/api/guided_search/create';
export const URL_XHR_UPLOAD_MEDIA_IMAGE = '/xhr/image/upload';
export const URL_XHR_PROFILE_PICTURE_EDIT = '/xhr/profile/picture/edit';
export const URL_XHR_UPLOAD_USERFILE = '/xhr/userfile/upload';
export const URL_USER_ORGANIZATION_TEAM = '/organization/team';
export const URL_USER_ORGANIZATION_TEAM_INVITATION = '/organization/team/invitation';
export const URL_USER_ORGANIZATION_TEAM_CHECK_EXISTS = '/organization/team/search';
export const URL_OFFER_QUESTION = '/offer/question';
export const URL_OFFER_CONTACT = '/xhr/offer/{hashId}/contact';
export const URL_OFFER_FAST_CONTACT_COMPLETION = '/offer/{hashId}/{contactFunnelType}/completion/{dealId}';
export const URL_SELLER_BRAND_UPDATE_PAGE_SPACE = '/xhr/page-spaces/{pageSpaceId}';
export const URL_SELLER_BRAND_CONTACT_PAGE_SPACE = '/xhr/page-spaces/{id}/contact';
export const URL_PAGE_SPACE_MEDIAS_UPLOAD = '/xhr/page-spaces/{id}/medias';
export const URL_PAGE_SPACE_MEDIA_DELETE = '/xhr/page-spaces/{id}/medias/{pageSpaceMediaId}';
export const SELLER_BRAND_PREFIX = 'partner';
export const PAY_CLIENT_BILLING_DOCUMENTS_ENDPOINT = '/xhr/pay_client_billing_documents';
export const PAY_BUYER_BILLING_DOCUMENTS_ENDPOINT = '/xhr/buyer/pay_client_billing_documents';
export const PAY_UBIQ_BILLING_DOCUMENTS_ENDPOINT = '/xhr/pay_ubiq_billing_documents';
export const PAY_SUBSCRIPTION_ENDPOINT = '/xhr/subscriptions';
export const URL_GEOCODE_PLACES = `/xhr/geocode/places/{id}`;
export const URL_XHR_USER_META_LAST_RESULTS_ACCESS = '/xhr/users/{id}/last_results_access';
export const URL_GEOCODE_ADDRESS_FROM_COORDINATES = '/xhr/geocode/latlng';
